import { ff } from '@atlassian/jira-feature-flagging';
import { KNOWN_COLUMN_TYPES } from './constants';
import type { KnownColumnType } from './types';

/**
 * Type predicate to determine that a value is not `null` or `undefined`.
 */
export function isNonNullish<T>(value: T | null | undefined): value is T {
	return value != null;
}

export function isKnownColumnType(value: string | undefined): value is KnownColumnType {
	// remove if statement when cleanup nin-support-request-type-field_ajjpk ff
	if (KNOWN_COLUMN_TYPES.REQUEST_TYPE === value && !ff('nin-support-request-type-field_ajjpk')) {
		return false;
	}

	return value !== undefined && Object.values<string>(KNOWN_COLUMN_TYPES).includes(value);
}

export function getProjectKeyFromIssueKey(issueKey: string): string {
	return issueKey.split('-')[0];
}

// TODO: escapeBackslashes serves as a temporary patch to convert jqlTerm into a format suitable for creator API.
// EM-6563 should resolve this by updating creator API to accept the semantic JQL value for jqlTerm currently returned by hydrateJqlQuery.
export const escapeBackslashes = (text: string) => text.replace(/\\/g, '\\\\');
